import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import LatestMoviesSection from './components/LatestMoviesSection';
import LatestTVShowsSection from './components/LatestTVShowsSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <LatestMoviesSection />
        <LatestTVShowsSection />
        <FeaturesSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}